import React from 'react'
import GoogleLogin from 'react-google-login';
import googleLogo from '../../assets/google.svg'

export const GoogleButton = ({ text, onSuccess }) => {

  const handelError = (data) => {
    console.log('error', data)
  }

  return (
    <GoogleLogin
      clientId="275810382880-ihvuq07er5530r2jk4c57g73fftcrjjq.apps.googleusercontent.com"
      buttonText={text}
      render={renderProps => (
        <button
          className='GoogleButton'
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
          type='button'
        >
          <img src={googleLogo} alt="logo de google" />
          {text}
        </button>
      )}
      onSuccess={onSuccess}
      onFailure={handelError}
      cookiePolicy={'single_host_origin'}
    />
  )
}